
import Vue from "vue";
import { getPhotoAnnounceHistory } from "@/api";

export default Vue.extend({
  name: "PhotoAnnounceHistory",
  data() {
    return {
      items: [] as any[],
      total: 0,
      loading: false,
      options: { page: 1, itemsPerPage: 25 } as any,
      filters: {
        target: "all",
        status: "all",
        from: "",
        to: ""
      },
      targetOptions: [
        { label: "All", value: "all" },
        { label: "Talent", value: "talent" },
        { label: "Offices", value: "office" }
      ],
      statusOptions: [
        { label: "All", value: "all" },
        { label: "Active", value: "active" },
        { label: "Removed", value: "removed" },
        { label: "Replaced", value: "replaced" },
        { label: "Expired", value: "expired" }
      ],
      headers: [
        { text: "Image", value: "imageUrl", sortable: false, width: "80px" },
        { text: "Website Link", value: "websiteLink", sortable: false },
        { text: "Target", value: "target", sortable: false, width: "90px" },
        { text: "Status", value: "status", sortable: false, width: "100px" },
        {
          text: "Uploaded",
          value: "uploadedAt",
          sortable: false,
          width: "240px"
        }
      ]
    };
  },
  watch: {
    options: {
      handler() {
        this.fetch();
      },
      deep: true
    }
  },
  created() {
    this.fetch();
  },
  methods: {
    capitalize(s: string): string {
      return s ? s.charAt(0).toUpperCase() + s.slice(1) : "";
    },
    statusColor(status: string): string {
      switch (status) {
        case "active":
          return "#13CA82";
        case "removed":
          return "#FB7672";
        case "expired":
          return "#F0A000";
        case "replaced":
        default:
          return "grey";
      }
    },
    formatTs(ts: string | null): string {
      if (!ts) return "—";
      const d = new Date(ts);
      if (isNaN(d.getTime())) return String(ts);
      const pad = (n: number) => String(n).padStart(2, "0");
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(
        d.getDate()
      )} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
    },
    reload() {
      this.options.page = 1;
      this.fetch();
    },
    async fetch() {
      this.loading = true;
      try {
        const params: any = {
          page: this.options.page || 1,
          pageSize: this.options.itemsPerPage || 25
        };
        if (this.filters.target !== "all") params.target = this.filters.target;
        if (this.filters.status !== "all") params.status = this.filters.status;
        if (this.filters.from) params.from = this.filters.from;
        if (this.filters.to) params.to = this.filters.to;
        const res = await getPhotoAnnounceHistory(params);
        this.items = res.data || [];
        this.total = res.total || 0;
      } catch (e) {
        this.items = [];
        this.total = 0;
      } finally {
        this.loading = false;
      }
    }
  }
});
